import React from 'react'

function Conversations({userDetails, userprompt, ai_response, streamResponse}) {
  return (
     <div className='my-6 w-full'>
                        <div className={`flex justify-end items-end mx-2 relative `}>
                            <div className='w-[85%] md:w-3/5 2xl:w-2/5'>
                                {userDetails &&
                                    <p className='flex justify-end font-bold text-sm
                                sm:text-[16px] my-1 sm:my-2.5 sm:mr-7'>
                                        {userDetails.name}</p>}
                                <p
                                    className={`my-2 sm:m-4 rounded-2xl p-2.5
                            bg-chatTipBackground text-black border-transparent `}
                                >
                                    {userprompt}
                                </p>
                            </div>
                        </div>

                        <div className={`flex justify-start items-start mt-3 mx-2 `}>
                            <div className='w-[90%] md:w-3/5 2xl:w-2/5'>
                                <p className='my-1 sm:m-2.5 font-bold
                        text-sm sm:text-[16px]'>OpenPolitica Bot</p>

                                <div className={`bg-chatTipBackground text-black sm:my-2.5 rounded-2xl`}>
                                    <div className={`rounded-t-lg p-4 border-transparent`}>
                                        {ai_response}
                                        {streamResponse && <span className="animate-ping ml-1">|</span>}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
  )
}

export default Conversations
